import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token : '',
    username : '',
    is_login : false,
    email : '',
    rootDir: '/', // 当前根目录
    currentSelectedDir: '/', // 当前选中的目录
    selectedImgPath: '', // 当前选中的图片
    currentFilePath: '', // 当前正在编辑的文件
    fileCache: new Map(), // 使用Map代替普通对象
    isLoadingContent: false,
    sourcePath: '', // 移动文件时的源文件/文件夹路径
    targetDir: '', // 移动文件时的目标目录
    showSelectDirModal: false, // 工作目录选择模态框
    showSelectImgModal: false, // 图片选择模态框
    showMoveModal: false, // 移动文件模态框
    currentSelectedType: 'dir', // 当前选中的类型, 可选值: 'file' 或 'dir'
    chooseImgSignal: false, // 图片选择信号, 用来通知编辑器组件插入图片, 编辑器组件监听该变量的变化, 如果发生变化则在编辑框中插入一张图片
    moveSignal: false, // 移动文件信号, 用来通知文件树组件移动文件
    // 文件夹刷新状态哈希表, key: 文件夹完整路径, value: 刷新时间戳
    folderRefreshFlags: {},
    folderExpanded : {},
    expandedFolders : new Set(),
    renderedContent : {},
  },
  
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },

    SET_EMAIL(state, email) {
      state.email = email;
    },
    
    SET_USERNAME(state, username) {
      state.username = username;
    },

    SET_IS_LOGIN(state, is_login){
      state.is_login = is_login;
    },

    SET_ROOT_DIR(state, rootDir) {
      state.rootDir = rootDir;
    },

    SET_CURRENT_SELECTED_DIR(state, currentSelectedDir) {
      state.currentSelectedDir = currentSelectedDir;
    },

    SET_SELECTED_IMG_PATH(state, selectedImgPath) {
      state.selectedImgPath = selectedImgPath;
    },

    SET_CURRENT_FILE_PATH(state, path) {
      state.currentFilePath = path;
    },

    SET_FILE_CACHE(state, { path, content }) {
      state.fileCache.set(path, content);
    },

    SET_IS_LOADING_CONTENT(state, isLoading) {
      state.isLoadingContent = isLoading;
    },
    
    SET_SOURCE_PATH(state, sourcePath) {
      state.sourcePath = sourcePath;
    },

    SET_TARGET_DIR(state, targetDir) {
      state.targetDir = targetDir;
    },

    SET_SHOW_SELECT_DIR_MODAL(state, show) {
      state.showSelectDirModal = show;
    },

    SET_SHOW_SELECT_IMG_MODAL(state, show) {
      state.showSelectImgModal = show;
    },

    SET_SHOW_MOVE_MODAL(state, show) {
      state.showMoveModal = show;
    },

    SET_CURRENT_SELECTED_TYPE(state, type) {
      state.currentSelectedType = type;
    },

    // 切换图片选择信号
    CHANGE_CHOOSE_IMG_SIGNAL(state) {
      state.chooseImgSignal = !state.chooseImgSignal;
    },

    // 切换移动文件信号
    CHANGE_MOVE_SIGNAL(state) {
      state.moveSignal = !state.moveSignal;
    },

    // 设置文件夹刷新标志（布尔值版本）
    CHANGE_FOLDER_REFRESH_FLAG(state, folderPath) {
      Vue.set(state.folderRefreshFlags, folderPath, !state.folderRefreshFlags[folderPath])
    },

    // 设置文件夹的开闭状态
    CHANGE_EXPANDED_FOLDERS(state, folderPath) {
      if (state.expandedFolders.has(folderPath)) {
        state.expandedFolders.delete(folderPath);
      } else {
        state.expandedFolders.add(folderPath);
      }
    },

    SET_RENDERED_CONTENT(state, renderedContent){
      state.renderedContent = renderedContent;
    },
  }
})